module.exports = __webpack_public_path__ + "img/mega-image.80685952.svg";